import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GettingStarted } from '../components/GettingStarted/GettingStarted';
import PageMain from '../components/Navigation/PageMain/PageMain';

export function GettingStartedPage() {
    const { classes } = useStyles();
    return (
        <PageMain pageTitle="Getting Started" showError={false} showLoading={false}>
            <GettingStarted />
        </PageMain>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
